module.exports = __webpack_public_path__ + "img/BFZN.0c51a9f2.png";